import React, { useContext, useState, useEffect } from 'react';
import store from '../../store';
import { newStoryTextObj, addFiveNewWords } from '../../constants/stories';
import {hasAnonymousUserContributed,
lessThan5Contributions, moreThan5Contributions} from '../../constants/verifications';
// Custom components
import { DefaultButton } from '../Buttons';
// Material components
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Divider
} from '@material-ui/core';
// Styles
import fonts from '../../assets/css/fonts';
import { flex } from '../../assets/jss';
import "./styles.css";
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    newWordsContainer: {
        ...flex.flex_row_start,
        flexWrap: 'wrap',
        margin: 5
    },
    newWords: {
        margin: '0px 5px',
        padding: 5,
        cursor: 'pointer',
        fontSize: '1.2rem',
        "&hover": {
            borderBottom: '2px solid'
        }
    },
    dialogPaper: {
        [theme.breakpoints.down('sm')]: {
            margin: 5,
            maxHeight: 'none',
            overflowY: 'scroll'
        }
    },
    textarea: {
        width: '100%',
        fontSize: 'large'
    }
}))
export default function AddWords({ story }) {
    const classes = useStyles();
    const { state } = useContext(store);
    const { user } = state;
    const { emailVerified, isAnonymous } = user;
    const [open, setOpen] = useState(false);
    const [newWord, setNewWord] = useState('');
    const [newWords, setNewWords] = useState([]);
    const [fontFamily, setFontFamily] = useState('');
    const [contributors, setContributors] = useState([]);
    const [contributorIDs, setContributorIDs] = useState([]);

    const fontFamilies = Object.values(fonts);
    let seperators = [',', '.', '/', '\\', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '-', '=', '{', '}', ':', ';', "'", '<', '>', " ", '+'];

    const handleOpen = () => {
        if (!emailVerified && !isAnonymous) {
            window.alert(`Your email has not been verified. Please check you email and activate your account. \nIf you did not receive the email, go to the Settings page and resend the verification email.`)
        } else {
            setOpen(open ? false : true);
        }

    };
    const handleFontFamilySelect = (e) => {
        if (user.isAnonymous) {
            window.alert('This feature is only available to users with verified accounts.')
        } else {
            setFontFamily(e.target.value)
        }

    }
    const handleRemoveWord = (word) => () => {
        setNewWords(newWords.filter((currentWords, i) => i !== word));
    }

    const checkContributor = () => {
        let errorMassege = `You can't currently add more words. Please check back later.`;
        if (hasAnonymousUserContributed(isAnonymous, contributors)) {
            window.alert('Anonymous users have to wait until 5 regular users have contributed.');
            return false;
        }
        if (lessThan5Contributions(contributorIDs, user)) {
            window.alert(errorMassege);
            return false;
        }
        if (moreThan5Contributions(contributorIDs, user)) {
            window.alert(errorMassege);
            return false;
        }
        return true;
    };
    const handleInput = (e) => {
        if (newWords.length === 5) {
            return;
        }
        let input = e.target.value;
        if (input.includes(" ") & input !== " ") {
            let word = input.slice(0, input.indexOf(" "));
            setNewWords(newWords.concat(word.trim()))
            setNewWord('');
            return;
        }

        let res = [];
        seperators.forEach((value) => {
            if (input.includes(value)) {
                res.push(input.split(value))
                return;
            }
        })

        if (res.length > 1) {
            window.alert('String has too many words and special characters.');
        } else if (res.length === 1 && res[0].length > 2) {
            window.alert('String has too many words seperated by the same special character.');
        } else {
            setNewWord(input.trim())
        }
    }
    const handleSubmit = () => {
        if (checkContributor()) {
            addFiveNewWords(story, newStoryTextObj(user, fontFamily, newWords), handleOpen);
        }
    }
    useEffect(() => {
        setContributors(story.text.map(txt => txt.contributor));
        setContributorIDs(story.contributors);
    }, [story])

    return (
        <div>
            <DefaultButton
                variant="light"
                onClick={handleOpen}>
                Add 5 words
            </DefaultButton>
            <Dialog classes={{
                paper: classes.dialogPaper
            }} open={open} onClose={handleOpen} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">To add words, type the word and press "space".</DialogTitle>
                <DialogContent>
                    {newWords.length === 0 ? null :
                        <span>Click word to remove</span>}
                    <div className={classes.newWordsContainer}>
                        {newWords.map((word, i) =>
                            <span key={i}
                                style={{ fontFamily: fontFamily }}
                                className='newWords'
                                onClick={handleRemoveWord(i)}>
                                {word}
                            </span>
                        )}
                    </div>

                    <textarea
                        autoFocus
                        onChange={handleInput}
                        style={{ fontFamily: fontFamily }}
                        value={newWord}
                        className={classes.textarea}
                        placeholder="5 words, no more, no less">
                    </textarea>

                    <Divider />
                    <FormControl fullWidth>
                        <InputLabel id="select-font-family">Select font family</InputLabel>
                        <Select
                            labelId="select-font-family"
                            id="demo-simple-select"
                            value={fontFamily}
                            onChange={handleFontFamilySelect}
                        >
                            {fontFamilies.map((font, i) => <MenuItem key={i} style={{ fontFamily: font }} value={font}>{font}</MenuItem>)}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <DefaultButton onClick={handleOpen} variant="dark">
                        Cancel
                    </DefaultButton>
                    {newWords.length !== 5 ? null :
                        <DefaultButton onClick={handleSubmit} variant="light">
                            Submit
                        </DefaultButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}